const Operations = Object.freeze({
    Create: Symbol("create"),
    Delete: Symbol("delete"),
    Update: Symbol("update")
});

export default Operations;